export default __webpack_public_path__ + "static/media/element_2.5e5f644b.webp";